import { render, staticRenderFns } from "./NcpTableBodyHead.vue?vue&type=template&id=08612657&"
import script from "./NcpTableBodyHead.vue?vue&type=script&lang=ts&"
export * from "./NcpTableBodyHead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports